<template>
  <Modal>
    <Modal.Body>
      <div class="flex flex-col items-center">
        <CheckedSolidIcon class="mt-6 mb-[18px] size-12 text-green-700" />
        <div class="font-medium text-[17px] leading-[24px]">
          {{ title }}
        </div>
        <div v-if="html" v-html="sanitizedHtml" class="mt-3 text-center"></div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="handleClick"
      >
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'
import { CheckedSolidIcon } from '@dacr/icons'
import { sanitizeHtml } from '@/shared/utils/sanitize'
import { useDevice } from '@/shared/composables/useDevice'

const props = defineProps<{
  title: string
  html?: string
  preventClose?: boolean
}>()

const { close, triggerEvent } = useModal()
const { isMobile } = useDevice()

const sanitizedHtml = computed(() =>
  props.html ? sanitizeHtml(props.html) : ''
)

const handleClick = () => {
  const triggered = triggerEvent('success')
  if (!triggered) close()
}
</script>
